import { anexosFunc, criancaFunc, servicoAcolhimentoFunc } from "../../helpers/Funcionalidades";

export const handleRestrictionAnexoServico = (categorias, roleKeycloack) => {
  const restrictions = [
    {
      check: () => roleKeycloack.includes(anexosFunc.anexoServicoVisualizarRestricao),
      categoriasToRemove: [
        "Oficio de Pessoa em Cumprimento de Pena",
        "Fotos do Serviço de Acolhimento",
        "Outros Anexos",
        "Termo do Voluntariado"
      ],
    },
    {
      check: () => roleKeycloack.includes(criancaFunc.visualizarTudoTutelar),
      categoriasToRemove: [
        "Fotos do Serviço de Acolhimento"
      ],
    },
    {
      check: () => roleKeycloack.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM),
      categoriasToRemove: [
        "Oficio de Pessoa em Cumprimento de Pena",
        "Termo do Voluntariado"
      ],
    },
  ];

  return categorias.filter(item => {
    return !restrictions.some(restriction =>
      restriction.check() && restriction.categoriasToRemove.includes(item[1])
    );
  });
};
